import React, { useState } from 'react'
import { MainContainer } from '../Components/Elements'
import PagesNav from '../Components/PagesNav'
import { Offcanvas, Table } from 'react-bootstrap'
import SearchInput from '../Components/SearchInput'
import AddInput from '../Components/AddInput'
import TeamHooks from '../hooks/MangmentHooks/TeamHooks'
import MainInput from '../Components/MainInput'
import TableBtns from '../Components/TableBtns'


const Management = () => {

    const {
      NavItems,
      setSearch,
      handleShow,
      show,
      handleClose
    } = TeamHooks()

  return <>
  <MainContainer>
    <div className='d-flex gap-3 mb-3 align-items-center'>
    <PagesNav links={NavItems}/>
    <div className='d-flex gap-2'>
    <SearchInput  search={e => setSearch(e.target.value)}/>
    <AddInput onClick={handleShow}/>
    </div>
    </div>

    <Table hover className='text-center'>
      <thead>
        <tr>
          <th className='bg-light'>Teams (English)</th>
          <th className='bg-light'>Teams (Arabic)</th>
          <th className='bg-light'>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Mark</td>
          <td>Otto</td>
          <td>
            <TableBtns/>
          </td>
        </tr>
      </tbody>
    </Table>
  
  </MainContainer>




  <Offcanvas show={show} onHide={handleClose} placement='end'>
        <Offcanvas.Header className='pt-5' closeButton>
          <Offcanvas.Title>Create New Team</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className='d-flex flex-column justify-content-between'>
          <div>
            <MainInput label={"Name*"} placeholder={"Enter Name....."}  required={true} type={"text"}/>
            <MainInput label={"*اسم"} placeholder={"....ادخل الاسم"} required={true} type={"text"} dir='rtl'/>
          </div>

          <div className='d-flex justify-content-center align-items-center pb-3'>
            <button className='btn bg-white text-main shadow-lg w-75 py-2 fw-bold'>Submit</button>
          </div>
   
        </Offcanvas.Body>
      </Offcanvas>

  </>
}

export default Management